import image from "src/assets/images/defaultThumbnail.png"

export const defaultThumbnail = image
